export interface SystemNotification {
  type: MessageType;
  message: string;
}

export enum MessageType {
  Info,
  Error,
}
